(() => {
  if (window.BVDailyCountdown) {
    window.BVDailyCountdown.refresh();
    return;
  }

  function refresh() {
    const clocks = document.querySelectorAll('[data-bv-daily-countdown]');
    if (!clocks.length) return;

    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const secondsLeft = Math.max(0, Math.floor((midnight.getTime() - now.getTime()) / 1000));
    const hours = String(Math.floor(secondsLeft / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((secondsLeft % 3600) / 60)).padStart(2, '0');
    const seconds = String(secondsLeft % 60).padStart(2, '0');
    const text = `${hours}:${minutes}:${seconds}`;

    clocks.forEach((clock) => {
      if (clock.textContent !== text) clock.textContent = text;
    });
  }

  window.BVDailyCountdown = { refresh };
  refresh();
  window.setInterval(refresh, 1000);
  document.addEventListener('shopify:section:load', refresh);
})();
